module.exports = __webpack_public_path__ + "static/img/B_Corp.56d3caa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/B_Corp.jpg
// module id = qEbA
// module chunks = 1